import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
const CameraLocationsDB = [

    {
        cameraLocationId: 'W01HOP01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Phiona Richards',
        cameraPosition: new Vector3(7.740, 1.500, 3.163), // use THREE.Vector3
        cameraRotation: new Euler(0.008, -1.527, 0.008),  //use THREE.Euler
    },
    {
        cameraLocationId: 'W01HOP02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Linzi Bright',
        cameraPosition: new Vector3(10.245, 1.500, 17.172),
        cameraRotation: new Euler(3.141, 0.207, 3.141),
    },

    {
        cameraLocationId: 'W01HOP03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Poetry',
        cameraPosition: new Vector3(-5.874, 1.500, 15.549),
        cameraRotation: new Euler(3.137, 1.479, -3.137),
    },

    {
        cameraLocationId: 'W01HOP04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Tina Heeley',
        cameraPosition: new Vector3(-7.946, 1.500, 2.871),
        cameraRotation: new Euler(0.000, -0.284, 0.000),
    },
    {
        cameraLocationId: 'W01HOP05',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Entrance',
        cameraPosition: new Vector3(-13.793 , 1.5, 1.108),
        cameraRotation: new Euler(-3.142, -.483, -3.142),
    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
